
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { JobMessage } from '../../../global/models'

@Component
export default class JobMessageComponent extends Vue {
  @Prop({ type: Object, required: true })
  private readonly message!: JobMessage

  @Prop({ type: Boolean, default: false })
  private readonly hideDetails!: boolean

  @Prop({ type: Boolean, default: false })
  private readonly ownMessage!: boolean

  private get justifyEnd() {
    return this.ownMessage
  }

  private get isSystemMessage() {
    return this.message.authorType === 'system'
  }

  private get isOtherMessage() {
    return !this.ownMessage && !this.isSystemMessage
  }
}
